// extracted by mini-css-extract-plugin
export default {"wrapper":"SwiperAmba_wrapper__MiKnS","info":"SwiperAmba_info__hRj7B","name":"SwiperAmba_name__470aG","stage":"SwiperAmba_stage__eUvBP"};